
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UspsComponent } from './usps.component';
import { UspComponent } from './usp.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    exports: [
        UspsComponent,
        UspComponent
    ],
    declarations: [
        UspsComponent,
        UspComponent
    ],
    providers: []
})
export class UspsModule {
}
